











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgMemberRow_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrgAdmin",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrgAdminActionMenu_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node ).hash = "438a8ddeaf5bc9c4f92cd7c6e0e5af8b";

export default node;
